import { RivalRow } from '@/components/RivalRow';
import { CellHexIcon } from '@/components/RivalScore';
import { formatNumber } from '@/lib/format';
import type { FeedActivity } from '@/lib/api';
import { useT } from '@/i18n/react';

/**
 * Az aktivitás-kártya alján futó rivális-sáv.
 *
 * UGYANAZ A KÁRTYA, MINT A PROFILON — a `RivalRow` tömör változata, ugyanazokkal
 * a HALMOZOTT számokkal (pl. +189 / −295 és 9× összecsapás) a szerző és a kör
 * fő károsultja között. Geri kifejezetten ezt kérte (2026-08-26): ne egy másik
 * mérték kerüljön ide hasonló képpel, mert az ugyanúgy néz ki, de mást mond.
 *
 * ⚠️ EGYETLEN ADAT SZÓL CSAK ERRŐL A KÖRRŐL: a bal felső pirula, a körben
 * elvett mezők száma. Szándékosan pontosan úgy néz ki, mint a jobb felső
 * szorzó — a kettő egymás párja, a sáv két felső sarkában.
 *
 * ⚠️ LOPÁS NÉLKÜL NINCS SÁV. Ha a kör senkitől nem vett el területet, nincs
 * rivális, akinek a mérlegét mutathatnánk — a szerver ilyenkor `null`-t ad.
 * Egy „mindenki más" sáv itt értelmetlen lenne.
 */
export function ActivityRivalBar({ item, mine }: { item: FeedActivity; mine: boolean }) {
  const t = useT();
  const rival = item.rival;
  if (!rival) return null;

  return (
    <RivalRow
      compact
      rival={rival}
      others={rival.others}
      /*
        A bal („nyert") sáv a KÖR SZERZŐJÉÉ, a jobb a riválisé — mindkettő a
        saját, választott cellaszínén, ugyanúgy, mint a térképen (Geri kérése,
        2026-08-29). Aki nem választott, annak az oldala marad a megszokott
        lila/korall.
      */
      selfCellColor={item.author.cellColor}
      selfName={mine ? t.feed.card.you : item.author.username}
      takenThisActivity={rival.cellsThisActivity}
      extra={
        <span className="rival-row__taken">
          <span aria-hidden="true">+{formatNumber(rival.cellsThisActivity)}</span>
          <CellHexIcon />
          <span className="rival-score__sr">
            {t.feed.card.cellsTaken(rival.cellsThisActivity, formatNumber(rival.cellsThisActivity))}
          </span>
        </span>
      }
    />
  );
}
